export enum Status {
  INIT = 'INIT',
  IN_PROGRESS = 'IN_PROGRESS',
}
